<template>
  <div class="vacancy-media-carousel">
    <div ref="carousel"
         class="vacancy-media-carousel__wrap">
      <div class="vacancy-media-carousel__list">
        <div v-if="!slides || !slides.length"
             class="vacancy-media-carousel__item  _placeholder">
        </div>
        <div class="vacancy-media-carousel__item"
             v-for="(item, index) in slides"
             :key="item.id"
             @click.prevent="onImgClick(index)"
        >
          <template v-if="item.type && isVideo(item)">
            <video>
              <source v-if="item.path_web"
                      :type="item.type"
                      :src="item.path_web">
              <source :type="item.type"
                      :src="item.path">
            </video>
            <div class="vacancy-media-carousel__video-play">
              <img src="../../assets/img/svg/play-small.svg"
                   alt="play"></div>
          </template>

          <picture v-else>
            <source v-if="item.path_web"
                    :srcset="item.path_web"
                    :type="item.type">
            <img :src="item.path"
                 :alt="item.id">
          </picture>
<!--          <div v-if="item.title"-->
<!--               class="vacancy-media-carousel__descr">-->
<!--            <BaseSvg name="ico-info"/>-->
<!--            <span>{{item.title}}</span>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div ref="pagination"
         class="vacancy-media-carousel__pagination"></div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import {VIDEOS_MIME_TYPES} from '../../constants/files'

  export default {
    name: 'VacancyMediaCarousel',
    props: {
      slides: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        swiper: null
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'vacancy-media-carousel__list',
          slideClass: 'vacancy-media-carousel__item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          centerInsufficientSlides: true,
          pagination: {
            el: this.$refs['pagination'],
            type: 'bullets',
            bulletClass: 'vacancy-media-carousel__pagination-item',
            bulletActiveClass: '_active',
            lockClass: '_hidden',
            clickable: true
          }
        })
      },
      isVideo(file) {
        return VIDEOS_MIME_TYPES.includes(file.type)
      },
      onImgClick(index) {
        this.$emit('gallery', index)
      }

    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy()
      }
    }
  }
</script>

<style>

</style>
